import { useEffect, useState } from 'react';

const pad = (n: number) => String(n).padStart(2, '0');

/** Counts down to `endsAt` (ISO). Ticks every second; floors at 00:00:00. */
export function Countdown({ endsAt }: { endsAt: string }) {
  const target = new Date(endsAt).getTime();
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const remaining = Math.max(0, Math.floor((target - now) / 1000));
  const h = Math.floor(remaining / 3600);
  const m = Math.floor((remaining % 3600) / 60);
  const s = remaining % 60;
  const Block = ({ v }: { v: number }) => (
    <b className="min-w-[26px] rounded-[3px] bg-[#1c1c1c] px-[5px] py-[3px] text-center text-[13px] font-extrabold text-white">
      {pad(v)}
    </b>
  );
  return (
    <div className="flex items-center gap-1">
      <span className="mr-1 text-[13px] font-semibold text-[#666]">Ending in</span>
      <Block v={h} />
      <span className="font-extrabold text-[#1c1c1c]">:</span>
      <Block v={m} />
      <span className="font-extrabold text-[#1c1c1c]">:</span>
      <Block v={s} />
    </div>
  );
}
